import React, { Component } from 'react'
import { Modal, Input } from 'hljd'
import { observer, inject } from 'mobx-react'
import GroupItem from '@components/LocalMerchant/SiDa/Common/GroupItem'
import { goToSiYiTeamHome } from '@components/LocalMerchant/SiDa/util'

@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      visible,
      setStoreData,
      onCompositionStart,
      onCompositionEnd,
      onApply,
      filterList,
      inputSearch
    } = this.props.store.joinGroupStore

    return (
      <Modal
        title="加入团队"
        visible={visible}
        onCancel={() => {
          setStoreData({ visible: false, inputSearch: '' })
        }}
        footer={null}
      >
        <Input.Search
          placeholder="请输入团队名称"
          // enterButton="搜索"
          size="large"
          style={{ marginBottom: '30px', height: '32px' }}
          // onSearch={value => getList({ name: value })}
          name="inputSearch"
          value={inputSearch}
          onChange={e => {
            const { name, value } = e.target
            setStoreData({ [name]: value })
          }}
          onCompositionStart={onCompositionStart}
          onCompositionEnd={onCompositionEnd}
        />

        {filterList.map(item => {
          return (
            <GroupItem
              key={item.id}
              item={item}
              onApply={onApply}
              selectedText="已申请"
              unSelectedText="申请"
              selectedKey="hasApply"
              onClick={() => goToSiYiTeamHome(item.id)}
              highlightText={inputSearch}
            />
          )
        })}
      </Modal>
    )
  }
}
